import { render, staticRenderFns } from "./zsyYingXiao.vue?vue&type=template&id=1061c4b5&"
import script from "./zsyYingXiao.vue?vue&type=script&lang=js&"
export * from "./zsyYingXiao.vue?vue&type=script&lang=js&"
import style0 from "./zsyYingXiao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports